import React, { useState, useEffect } from "react";
import Colors from "../../../../stories/assets/Colors";
import Fonts from "../../../../stories/assets/Fonts";
import { Button } from "../../../../stories/Button/Button";
import {
  FolderIconBlue,
  ArrowUpRightBlue,
  AddIconGray,
  AddIconBlue,
} from "../../../../constant/imagePath";
import { BeforeLoginHeader } from "../../../../stories/BeforeLoginHeader/BeforeLoginHeader";
import { Row, Col, Container } from "react-bootstrap";
import { LinkButtonWithIcon } from "../../../../stories/LinkButtonWithIcon/LinkButtonWithIcon.jsx";
import classes from "./AddFaq.module.css";
import Map from "../../../CustomMap/CustomMap";
import { Input } from "../../../../stories/Input/Input";
import { DropDown } from "../../../../stories/DropDown/DropDown";
import { TextArea } from "../../../../stories/TextArea/TextArea";
import { CommonQuestions } from "../../../../stories/CommonQuestions/CommonQuestions";
import { isMobileViewHook } from "../../../../CustomHooks/isMobileViewHook";
import AddFaqMobile from "./AddFaqMobile";
import AddQuestionModal from "../../../Modals/CoachFlow/OnBoarding/AddAQuestion/AddAQuestion";
import { func } from "prop-types";
import PageProgressBar from "../../../../stories/PageProgressBar/PageProgressBar";
import { setPersonalData } from "../../../../store/Actions/authAction";
import { useDispatch, useSelector } from "react-redux";

function AddFaqDesktop({ stepForwardAndBackward }) {
  const dispatch = useDispatch();
  const getDataFromRedux = useSelector((state) => state.onBoardingReducer?.faq);

  const [faqData, setFaqData] = useState(
    getDataFromRedux ? getDataFromRedux : []
  );
  const [question, setQuestion] = useState(null);
  const [answer, setAnswer] = useState("");
  const [editingData, setEdititngData] = useState();
  const [editingId, setEdititngId] = useState();
  const [isEditing, setIsEditing] = useState(false);
  const [isAdding, setIsAdding] = useState(false);

  // Save And Finish Later
  function saveAndFinishLater() {
    dispatch(setPersonalData("faq", faqData));
  }

  console.log({ faqData });

  function handleDelete(item) {
    const newFaqData = faqData?.slice();
    const index = newFaqData.findIndex((data) => data?._id === item?._id);
    newFaqData?.splice(index, 1);
    setFaqData(newFaqData);
  }
  function handleEdit(item) {
    setIsEditing(true);
    setEdititngData({
      _id: item?._id,
      answer: item?.description,
      question: { label: item?.title, value: item?.title },
    });
  }

  function editFaq(data) {
    console.log({ data });
    const newArr = [...faqData];
    const index = newArr?.findIndex((item) => item?._id == data?._id);
    newArr[index] = data;
    setFaqData(newArr);
  }
  function addFaqData() {
    const newArr = [...faqData];
    const ranId = Math.random() * 1000;
    newArr.push({ _id: ranId, answer: answer, question: question?.label });
    setFaqData(newArr);
  }
  function addFaqDataForModal(data) {
    const newArr = faqData?.slice();
    newArr.push(data);
    setFaqData(newArr);
  }

  return (
    <div className={classes.addFaq}>
      <div className={classes.progressLine}>
        <PageProgressBar progress={"66.6%"} />
      </div>

      <Row className={`g-0 ${classes.row}`}>
        <Col md={12}>
          <Col md={12} className={`${[classes.saveAndFinish].join(" ")}`}>
            <LinkButtonWithIcon
              text={"Save and Finish Later"}
              customStyle={{
                color: Colors.neutralShadesOfNero,
                ...Fonts.b2,
                lineHeight: "20px",
              }}
              onClick={saveAndFinishLater}
            />
          </Col>
          <Container fluid className={classes.innerContainer}>
            <Col md={12} className={classes.mt32}>
              <h3
                style={{
                  ...Fonts.h3,
                  color: Colors.neutralShadesOfNero,
                }}
              >
                Add FAQ
              </h3>

              <p
                className={classes.oneOnOne}
                style={{ ...Fonts.p2, color: Colors.neutralShadesOfDimGray }}
              >
                1-on-1 lesson
              </p>
            </Col>{" "}
            {faqData?.length > 0 && (
              <Col md={12} className={classes.mb32}>
                <CommonQuestions
                  data={faqData?.map((item) => ({
                    _id: item?._id,
                    title: item?.question,
                    description: item?.answer,
                  }))}
                  handleDelete={handleDelete}
                  handleEdit={handleEdit}
                  btnsPosition={"Top"}
                />
              </Col>
            )}
            {faqData?.length == 0 && (
              <>
                <Col md={12}>
                  <DropDown
                    label={"Question"}
                    placeholder={"Select Question"}
                    options={[{ value: "abc", label: "ABC" }]}
                    setter={setQuestion}
                    state={question}
                  />
                </Col>
                <Col md={12} className={classes.mt32}>
                  <TextArea
                    label={"Answer"}
                    placeholder={""}
                    textAreaStyle={{ minHeight: "164px", maxHeight: "146px" }}
                    state={answer}
                    setter={setAnswer}
                  />
                </Col>
              </>
            )}
            <Col md={12} className={classes.addMoreBtnBox}>
              <LinkButtonWithIcon
                leftIcon={AddIconBlue}
                text={"Add more"}
                primary={true}
                disabled={
                  (faqData?.length == 0 &&
                    (answer == "" || (question == null && true))) ||
                  false
                }
                iconStyle={{
                  marginRight: "10px",
                }}
                onClick={
                  faqData?.length == 0
                    ? () => addFaqData()
                    : () => setIsAdding(true)
                }
              />
            </Col>
          </Container>
        </Col>
        {/* Buttons Col */}
        <Col
          md={12}
          style={{
            borderTop: `1px solid ${Colors.neutralShadesOfGainsboro}`,
          }}
          className={classes.btnsCol}
        >
          <div className={classes.btnsBox}>
            <Button
              label={"Back"}
              size={"Large"}
              customStyle={{ width: "162px", height: "56px" }}
              onClick={() => stepForwardAndBackward(2, 2)}
            />
            <Button
              label={"Next"}
              primary={true}
              size={"Large"}
              customStyle={{ width: "162px", height: "56px" }}
              onClick={() => {
                saveAndFinishLater();
                stepForwardAndBackward(2, 4);
              }}
            />
          </div>
        </Col>
      </Row>
      {isAdding && (
        <AddQuestionModal
          show={isAdding}
          setShow={setIsAdding}
          onAdd={addFaqDataForModal}
        />
      )}
      {isEditing && (
        <AddQuestionModal
          show={isEditing}
          setShow={setIsEditing}
          onAdd={editFaq}
          data={editingData}
          isEditing
        />
      )}
    </div>
  );
}

export default function AddFaq({ stepForwardAndBackward }) {
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    isMobileViewHook(setIsMobile, 992);
  }, []);
  return isMobile ? (
    <AddFaqMobile stepForwardAndBackward={stepForwardAndBackward} />
  ) : (
    <AddFaqDesktop stepForwardAndBackward={stepForwardAndBackward} />
  );
}
